import * as yup from 'yup'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { useTranslation } from 'react-i18next'

export const useFormRules = () => {
  const { t } = useTranslation()

  const messageAccountFileRequired = t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
    Required_Field: `${t('ACHExceptionRule:uploadModal.uploadFile.uploadFile')}`,
  })

  return {
    uploadACHFile: {
      required: {
        value: true,
        message: messageAccountFileRequired,
      },
    },
  }
}

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    clientNames: yup
      .string()
      .nullable()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ACHExceptionRule:client.error')}`,
        }),
      ),
    // accountNames: yup.array().min(
    //   1,
    //   t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
    //     Required_Field: `${t('ACHExceptionRule:account.error')}`,
    //   }),
    // ),
  })

  return validationSchema
}

export { generateValidationSchema }
